import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import SkeletonBar from "./SkeletonBar";

type MailRowSkeletonProps = {
    squeeze?: boolean;
};

const MailRowSkeleton = ({ squeeze = false }: MailRowSkeletonProps) => (
    <Card
        className={cn(
            "pointer-events-none overflow-hidden border-2 border-white/30 bg-white/30 shadow-sm",
            squeeze ? "max-h-31" : "max-h-23",
        )}
        display="grid"
        size={squeeze ? "1x4" : "12x1"}
        variant="read"
    >
        {squeeze ? (
            <>
                <div className="row-span-3 flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <SkeletonBar className="h-4 w-4 shrink-0 rounded-sm" />
                        <SkeletonBar className="h-3 w-14" />
                    </div>
                    <SkeletonBar className="h-4 w-28" />
                    <SkeletonBar className="h-3.5 w-full max-w-[120px]" />
                    <SkeletonBar className="h-3.5 w-full max-w-[160px]" />
                </div>
                <div className="row-start-4 flex items-center justify-between">
                    <SkeletonBar className="h-3 w-10" />
                    <SkeletonBar className="h-3 w-14" />
                </div>
            </>
        ) : (
            <>
                <div className="col-span-3 flex items-center gap-2 pr-10">
                    <SkeletonBar className="h-4 w-4 shrink-0 rounded-sm" />
                    <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                        <div className="flex items-center gap-2">
                            <SkeletonBar className="h-5 w-5 shrink-0" round />
                            <SkeletonBar className="h-3.5 w-24 max-w-full" />
                        </div>
                        <SkeletonBar className="h-3.5 w-full max-w-[180px]" />
                    </div>
                </div>

                <div className="col-span-6 col-start-4 my-auto ml-4 h-12 rounded-lg bg-surface-primary p-2 pl-4 pr-5 xl:col-span-7">
                    <SkeletonBar className="h-full w-full rounded-md" />
                </div>

                <div className="col-span-2 col-start-11 flex flex-col items-end justify-center gap-2">
                    <div className="flex items-center gap-3">
                        <SkeletonBar className="h-3.5 w-8" />
                        <SkeletonBar className="h-3.5 w-12" />
                    </div>
                    <SkeletonBar className="h-3 w-16" />
                    <SkeletonBar className="h-3 w-20" />
                </div>
            </>
        )}
    </Card>
);

export default MailRowSkeleton;
